import { render, staticRenderFns } from "./MixerUploadsDetail.vue?vue&type=template&id=afe1f09a&scoped=true&lang=pug&"
import script from "./MixerUploadsDetail.vue?vue&type=script&lang=js&"
export * from "./MixerUploadsDetail.vue?vue&type=script&lang=js&"
import style0 from "./MixerUploadsDetail.vue?vue&type=style&index=0&id=afe1f09a&scoped=true&lang=css&"
import style1 from "./MixerUploadsDetail.vue?vue&type=style&index=1&id=afe1f09a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe1f09a",
  null
  
)

export default component.exports